export default __webpack_public_path__ + "static/media/catBanner.e7e3ff9b.jpg";